import {
GET_DROPDOWN_USERS,
OFFICE_USER_MENUS,
GET_DSPUSER,
GET_DSP_USERS_LIST,
GET_DSP_USER_1,
GET_DSP_USER_RETAILER,
GET_ADMIN_USERS_1
} from "../../admin-constants";
import UserService from "../../../services/admin/user.service";
import { showLoader, hideLoader } from "../../common/actions";
import {showModal} from "../../modal/actions";
import { GET_INVOICE_MENUS } from "../../admin-constants";

export const getOfficeUsersDropdown = (data) => async (dispatch) => {
  try {
    const resultData = await UserService.getOfficeUsersDropdown(data);
    if (resultData?.status) {
      dispatch({
        type: GET_DROPDOWN_USERS,
        payload: resultData?.status && resultData?.data ? resultData.data : [],
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const getOfficeUsersMenu = (data) => async (dispatch) => {
    try {
    dispatch(showLoader());
    const resultData = await UserService.getOfficeUsersMenu(data);
    if (resultData?.status) {
      dispatch({
        type: OFFICE_USER_MENUS,
        payload: resultData?.status && resultData?.data ? JSON.parse(resultData.data) : [],
      });
    }
  } catch (err) {
    console.log(err);
  } finally {
      dispatch(hideLoader());
    }

};


export const updateInvoiceMenu = (data) => async (dispatch) => {
    try {

    dispatch(showLoader());
    const resultData = await UserService.updateInvoiceMenu(data);
    if(resultData?.status) {
       dispatch(showModal({
            title: "Success",
            message: "Updated successfully",
            iconType: "success",
            autoClose: true,
            autoCloseTime: 1800,
          }));
    } else {
      dispatch(showModal({
            title: "Failure",
            message: "Something wrong while updating",
            iconType: "error",
            autoClose: true,
            autoCloseTime: 1800,
          }));
    }
  } catch (err) {
    console.log(err);
  } finally {
      dispatch(hideLoader());
    }

    

};


export const getDspusertype = () => async (dispatch) => {
  try {
    const resultData = await UserService.getDspusertype();


    dispatch({
      type: GET_DSPUSER,
      payload: resultData?.status && resultData?.data ? resultData.data : [],
    });
  } catch (err) {
    console.log(err);
  }
};

export const getDspUserList = (data) => async (dispatch) => {
  try {
    const resultData = await UserService.getDspUserList(data);
    if (resultData?.status) {
      dispatch({
        type: GET_DSP_USERS_LIST,
        payload: resultData?.status && resultData?.data ? resultData.data : [],
      });
    }
  } catch (err) {
    console.log(err);
  }
};
export const getDspUser_1 =
  (data, userRetailer = null) =>
  async (dispatch) => {
    try {
      const resultData = await UserService.getDspUser_1(data);
      let actionType = GET_DSP_USER_1;
      if (userRetailer !== null) {
        if (!userRetailer) {
          actionType = GET_DSP_USER_RETAILER;
        }
      }
      if (resultData?.status) {
        dispatch({
          type: actionType,
          payload:
            resultData?.status && resultData?.data ? resultData.data : [],
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
export const getDspUser1 = () => async (dispatch) => {
  try {
    const resultData = await UserService.getDspUser1();
    dispatch({
      type: GET_ADMIN_USERS_1,
      payload: resultData?.status && resultData?.data ? resultData.data : [],
    });
  } catch (err) {
    console.log(err);
  }
};

export const getInvoiceMenus = () => async (dispatch) => {
  try {
    dispatch(showLoader());

    const resultData = await UserService.getInvoiceMenu();

   if (Array.isArray(resultData)) {
      dispatch({
        type: GET_INVOICE_MENUS,
        payload: resultData,
      });
    }
  } catch (err) {
    console.log(err);
  } finally {
    dispatch(hideLoader());
  }
};